let planetinfo = [
	{"position": "1",
	 "name": "Mercury",
	 "image": "http://space-facts.com/wp-content/uploads/mercury-transparent.png",
	 "velocity": "47",
	 "distance": "58",
	 "description": "Mercury is the closest planet to the Sun and due to its proximity it is not easily seen except during twilight. For every two orbits of the Sun, Mercury completes three rotations about its axis and up until 1965 it was thought that the same side of Mercury constantly faced the Sun. Thirteen times a century Mercury can be observed from the Earth passing across the face of the Sun in an event called a transit, the next will occur on the 9th May 2016."
	},
	{"position": "2",
	 "name": "Venus",
	 "image": "http://space-facts.com/wp-content/uploads/venus-transparent.png",
	 "velocity": "35",
	 "distance": "108",
	 "description": "Venus is the second planet from the Sun and is the second brightest object in the night sky after the Moon. Named after the Roman goddess of love and beauty, Venus is the second largest terrestrial planet and is sometimes referred to as the Earth’s sister planet due the their similar size and mass. The surface of the planet is obscured by an opaque layer of clouds made up of sulphuric acid."
	},
	{"position": "3",
	 "name": "Earth",
	 "image": "http://space-facts.com/wp-content/uploads/earth-transparent.png",
	 "velocity": "29",
	 "distance": "149",
	 "description": "Earth is the third planet from the Sun and is the largest of the terrestrial planets. The Earth is the only planet in our solar system not to be named after a Greek or Roman deity. The Earth was formed approximately 4.54 billion years ago and is the only known planet to support life."
	},
	{"position": "4",
	 "name": "Mars",
	 "image": "http://space-facts.com/wp-content/uploads/mars-transparent.png",
	 "velocity": "24",
	 "distance": "227",
	 "description": "Mars is the fourth planet from the Sun and is the second smallest planet in the solar system. Named after the Roman god of war, Mars is also often described as the “Red Planet” due to its reddish appearance. Mars is a terrestrial planet with a thin atmosphere composed primarily of carbon dioxide."
	},
	{"position": "5",
     "name": "Jupiter",
	 "image": "http://space-facts.com/wp-content/uploads/jupiter-transparent.png",
	 "velocity": "13",
	 "distance": "778",
	 "description": "The planet Jupiter is the fifth planet out from the Sun, and is two and a half times more massive than all the other planets in the solar system combined. It is made primarily of gases and is therefore known as a “gas giant”."
	},
	{"position": "6",
	 "name": "Saturn",
	 "image": "http://space-facts.com/wp-content/uploads/saturn-transparent.png",
	 "velocity": "9",
	 "distance": "1426",
	 "description": "Saturn is the sixth planet from the Sun and the most distant that can be seen with the naked eye. Saturn is the second largest planet and is best known for its fabulous ring system that was first observed in 1610 by the astronomer Galileo Galilei. Like Jupiter, Saturn is a gas giant and is composed of similar gasses including hydrogen, helium and methane."
	},
	{"position": "7",
	 "name": "Uranus",
	 "image": "http://space-facts.com/wp-content/uploads/uranus-transparent.png",
	 "velocity": "6",
	 "distance": "2870",
	 "description": "Uranus is the seventh planet from the Sun. While being visible to the naked eye, it was not recognised as a planet due to its dimness and slow orbit. Uranus became the first planet discovered with the use of a telescope. Uranus is tipped over on its side with an axial tilt of 98 degrees. It is often described as “rolling around the Sun on its side.”"
	},
	{"position": "8",
	 "name": "Neptune",
	 "image": "http://space-facts.com/wp-content/uploads/neptune-transparent.png",
	 "velocity": "5",
	 "distance": "4498",
	 "description": "Neptune is the eighth planet from the Sun making it the most distant in the solar system. This gas giant planet may have formed much closer to the Sun in early solar system history before migrating to its present position."
	},
	{"position": "9",
	 "name": "Sun",
	 "image": "http://pngimg.com/uploads/sun/sun_PNG13424.png",
	 "velocity": "220",
	 "distance": "0",
	 "description": "The Sun (or Sol), is the star at the centre of our solar system and is responsible for the Earth’s climate and weather. The Sun is an almost perfect sphere with a difference of just 10km in diameter between the poles and the equator. The average radius of the Sun is 695,508 km (109.2 x that of the Earth) of which 20–25% is the core."
	},
	{"position": "10",
	 "name": "Moon",
	 "image": "https://space-facts.com/wp-content/uploads/moon-transparent.png",
	 "velocity": "150",
	 "distance": "0",
	 "description": "The Moon (or Luna) is the Earth’s only natural satellite and was formed 4.6 billion years ago around some 30–50 million years after the formation of the solar system. The Moon is in synchronous rotation with Earth meaning the same side is always facing the Earth. The first uncrewed mission to the Moon was in 1959 by the Soviet Lunar Program with the first crewed landing being Apollo 11 in 1969."
	}
];

let constellationinfo = [
    {
        "name": "Andromeda",
        "abbr": "And",
        "best": "27-Nov",
        "season": "Autumn",
        "month": "November",
        "description": `Formed of stars spreading out from one of the stars in the Pegasus Square, this constellation is home to our neighbor, the Andromeda Galaxy, over 2.3 million light-years away. In dark skies the galaxy can be seen with the unaided eye. Viewed with binoculars it appears like a glowing cloud.`,
        "image" : "https://www.astropical.space/images/cns/grid_icon_mark_and_large.png"
    },
    {
        "name": "Antlia",
        "abbr": "Ant",
        "best": "17-Apr",
        "season": "Spring",
        "month": "April",
        "description": `Located opposite of Crater with Hydra in between, this constellation is merely made of 4th and 5th-magnitude stars which are difficult to glimpse in cities because of its low elevation in the south. Antlia is derived from vacuum pumps used in the 18th century for scientific experiments.`,
        "image" : "https://www.astropical.space/images/cns/grid_icon_mark_ant_large.png"
    },
    {
        "name": "Apus",
        "abbr": "Aps",
        "best": "18-Jul",
        "season": "South Polar",
        "month": "July",
        "description": `Located near the celestial south pole, Apus is a small constellation tying up three 4th-magnitude stars in a triangle. "Apus" is Latin for a breed of paradise birds native to New Guinea with very beautifully colored feathering. The constellation was invented in the 17th century by the astronomer Johann Bayer.`,
        "image": "https://www.astropical.space/images/cns/grid_icon_mark_aps_large.png"
    },
    {
        "name": "Aquarius",
        "abbr": "Aqr",
        "best": "22-Oct",
        "season": "Autumn",
        "month": "October",
        "description": `One of the 12 zodiac constellations located north of Piscis Austrinus. Consisting of dim stars it is a bit difficult to pinpoint. Its mark is a triple bow shape. The "water bearer" holds the beauteous youth Ganymede.`,
        "image": "https://www.astropical.space/images/cns/grid_icon_mark_aps_large.png"
    },
    {
        "name": "Aquila",
        "abbr": "Aql",
        "best": "10-Sep",
        "season": "Summer",
        "month": "September",
        "description": `Located north of Sagittarius, the constellation picture shows Zeus taking the beauteous youth Ganymede away to the upper region of the sky. The 1st-magnitude star Altair is one of the stars forming the Summer Triangle. Lying in the Milky Way, Aquila contains numerous planetary nebulae and open star clusters.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_aql_large.png`
    },
    {
        "name": "Ara",
        "abbr": "Ara",
        "best": "5-Aug",
        "season": "Summer",
        "month": "July",
        "description": `Located south of Scorpio, Ara consists of eight rather dim stars. It can be seen in the south at northern latitudes below 20 degrees. Ara can be found looking from the tail of Scorpius downwards towards the horizon.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_ara_large.png`
    },
    {
        "name": "Aries",
        "abbr": "Ari",
        "best": "25-Dec",
        "season": "Autumn",
        "month": "December",
        "description": `One of the 12 zodiac constellations which lies south of Andromeda with Triangulum in between. About 2,000 years ago it was the zero-point of the zodiac, however, nowadays, the vernal equinox is precessing towards Pisces.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_ari_large.png`
    },
    {
        "name": "Auriga",
        "abbr": "Aur",
        "best": "15-Feb",
        "season": "Winter",
        "month": "February",
        "description": `Located north of Taurus, Auriga's characteristics are the 1st-magnitude star Capella and its pentagon-shaped appearance. At the feet of the "charioteer" are three open star clusters, an enjoyable view in binoculars. Because the Milky Way runs through Auriga it delights with numerous open clusters and other deep sky objects.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_aur_large.png`
    },
    {
        "name": "Bootes",
        "abbr": "Boo",
        "best": "26-Jun",
        "season": "Spring",
        "month": "June",
        "description": `Marked by the 1st-magnitude star Arcturus, this constellation resembles the shape of a necktie. Arcturus is found in the northern spring sky by drawing a curve southwards from the leftmost star of the handle of the Big Dipper.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_boo_large.png`
    },
    {
        "name": "Caelum",
        "abbr": "Cae",
        "best": "29-Jan",
        "season": "Winter",
        "month": "January",
        "description": `A constellation without distinctive stars located behind of the "river" in Eridanus and opposite of Fornax. Its constellation picture represents two chisels. In the 18th century, astronomer Louis de Lacaille introduced Caelum to fill up space between the constellations.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cae_large.png`
    },
    {
        "name": "Camelopardalis",
        "abbr": "Cam",
        "best": "10-Feb",
        "season": "North Polar",
        "month": "February",
        "description": `Located next to Ursa Minor, a constellation without distinct bright stars. It was originally invented as the constellation of the Camel but was erroneously conveyed because of the similarity in the Latin spelling of camel (camelus) and giraffe (camelopardalis).`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cam_large.png`
    },
    {
        "name": "Cancer",
        "abbr": "Cnc",
        "best": "26-Mar",
        "season": "Spring",
        "month": "March",
        "description": `Located west of Leo, this is one of the 12 zodiac constellations and the first constellation of spring. With its dim stars, it is hard to find. The open star cluster M44, Praesepe, in the carapace of the "crab" is a must-see with binoculars.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cnc_large.png`
    },
    {
        "name": "Canes Venatici",
        "abbr": "CVn",
        "best": "2-Jun",
        "season": "Spring",
        "month": "May",
        "description": `Located south of the Big Dipper. Way back this constellation was a part of Ursa Major. In the 17th century, it was given independency as a new constellation by astronomer Johannes Hevelius. A large and a small galaxy, M51 (Whirlpool Galaxy), appear to be connected.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cvn_large.png`
    },
    {
        "name": "Canis Major",
        "abbr": "CMa",
        "best": "26-Feb",
        "season": "Winter",
        "month": "February",
        "description": `Canis Major's mark is the brightest star in the night sky, Sirius. In the constellation picture, Sirius represents the mouth of the "dog". The star connecting constellation lines allow easy recognition of the dog-shape. South of Sirius is the star cluster M41, beautiful to see in binoculars. The five brightest stars are printed on the flag of Brazil to represent 5 of its 27 states.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cma_large.png`
    },
    {
        "name": "Canis Minor",
        "abbr": "CMi",
        "best": "11-Mar",
        "season": "Winter",
        "month": "March",
        "description": `Located south of Gemini, its only mark is the 1st-magnitude star Procyon one of the Winter Triangle stars. Since the constellation contains just one more 3rd-magnitude star, Gomeisa, it is impossible to fancy a "little dog". On the flag of Brazil Procyon represents the state of Amazonas.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cmi_large.png`
    },
    {
        "name": "Capricornus",
        "abbr": "Cap",
        "best": "30-Sep",
        "season": "Summer",
        "month": "September",
        "description": `Located west of Aquarius, Capricorn is one of the 12 zodiac constellations. It has no particularly bright stars but can be found easily looking for a rounded triangle. In constellation pictures, mysteriously, its upper half is a goat, its lower a fish.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cap_large.png`
    },
    {
        "name": "Carina",
        "abbr": "Car",
        "best": "28-Mar",
        "season": "Winter",
        "month": "March",
        "description": `The second brightest star in the night sky shining south of Sirius in Canis Major, 1st-magnitude Canopus, is the mark of this constellation. Barely visible above the horizon at 35 degrees northern latitude, Canopus appears to be of red color. Carina is Latin for "keel" (of a ship). On the flag of Brazil Canopus represents the state of Goias.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_car_large.png`
    },
    {
        "name": "Cassiopeia",
        "abbr": "Cas",
        "best": "2-Dec",
        "season": "North Polar",
        "month": "November",
        "description": `A constellation named after the Aethiopian queen Cassiopeia which never sets for observers at over 35 degrees northern latitudes and is always visible in the northern sky. In spring and summer (when closer to the horizon) it resembles the letter W, while in autumn and winter (when high up in the evening sky) the letter M. Alongside the Big Dipper, Cassiopeia is a milestone which helps find the Northern Pole Star.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cas_large.png`
    },
    {
        "name": "Centaurus",
        "abbr": "Cen",
        "best": "7-Jun",
        "season": "Spring",
        "month": "May",
        "description": `A constellation which can be seen in the northern hemisphere between spring and the beginning of summer, but you need to be at 20 degrees latitude or less to see it in whole. Located at the feet of the constellation picture are the 1st-magnitude stars Rigil Kentaurus (Alpha Centauri) and Hadar (Beta Centauri). The globular cluster Omega Centauri is another famous object.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cen_large.png`
    },
    {
        "name": "Cepheus",
        "abbr": "Cep",
        "best": "17-Oct",
        "season": "North Polar",
        "month": "October",
        "description": `Located near the Northern Pole Star, this constellation can be seen all through the year at northern latitudes over 30 degrees. It contains no particularly bright stars, but its eyemark is its pentagon shape pointing at the Northern Pole Star. Because of its deep red color "Herschel's Garnet Star" or "Erakis"is a beautiful star in the lower part of Cepheus.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cep_large.png`
    },
    {
        "name": "Cetus",
        "abbr": "Cet",
        "best": "13-Dec",
        "season": "Autumn",
        "month": "December",
        "description": `A constellation lying in the south of the Pegasus Square with Pisces in between. The star in the tail of the "whale" is Deneb Kaitos. Near the throat is Mira, a popular variable star changing its brightness in a one-year period.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cet_large.png`
    },
    {
        "name": "Chamaeleon",
        "abbr": "Cha",
        "best": "28-Apr",
        "season": "South Polar",
        "month": "April",
        "description": `Invented in the 15th and 16th century by sea voyagers, this constellation first appeared in Bayer's star atlas in the 17th century as one of the 12 southern constellations. It consists of faint stars and can only be seen in the southern hemisphere owing to its location near the celestial south pole.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cha_large.png`
    },
    {
        "name": "Circinus",
        "abbr": "Cir",
        "best": "30-Jun",
        "season": "South Polar",
        "month": "June",
        "description": `Invented in the 18th century by astronomer Louis de Lacaille, this constellation lies south of Centaurus resembling a compass with its long and thin V shape. The principle star is 3.2 magnitudes bright. Circinus is Latin for a draftsman's compass, unlike Pyxis, which is Latin for a mariner's compass.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cir_large.png`
    },
    {
        "name": "Columba",
        "abbr": "Col",
        "best": "10-Feb",
        "season": "Winter",
        "month": "February",
        "description": `Located southwest of Canis Major, this constellation depicts the shape of the letter T formed by 3rd-magnitude stars. Modelled after the dove in the Old Testimony, the constellation picture draws a dove holding a branch in its mouth.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_col_large.png`
    },
    {
        "name": "Coma Berenices",
        "abbr": "Com",
        "best": "28-May",
        "season": "Spring",
        "month": "May",
        "description": `Located south of the Big Dipper and west of Bootes. It contains no bright stars, but the open star cluster Mel (Melotte) 111, a gathering of about 40 stars which can be observed with binoculars.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_com_large.png`
    },
    {
        "name": "Corona Australis",
        "abbr": "CrA",
        "best": "25-Aug",
        "season": "Summer",
        "month": "August",
        "description": `Located south of Sagittarius. Lacking bright stars, this constellation is difficult to spot in cities. Looking down from the "Little Milk Dipper" in Sagittarius, stars arranged in a semicircle come out in dark skies.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cra_large.png`
    },
    {
        "name": "Corona Borealis",
        "abbr": "CrB",
        "best": "13-Jul",
        "season": "Summer",
        "month": "July",
        "description": `A small constellation east of Bootes. Its most significant mark is the 2nd-magnitude star Alphecca which lines up with six other stars to form a semicircle. The merged shape renders the constellation relatively hard to find.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_crb_large.png`
    },
    {
        "name": "Corvus",
        "abbr": "Crv",
        "best": "23-May",
        "season": "Spring",
        "month": "May",
        "description": `Located south of Virgo it draws a cracked trapezium with four 3rd-magnitude stars. In constellation pictures, it is drawn as a mischievous crow nailed to the sky while it is said that only the head of the nail is visible.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_crv_large.png`
    },
    {
        "name": "Crater",
        "abbr": "Crt",
        "best": "8-May",
        "season": "Spring",
        "month": "April",
        "description": `A small constellation located between Leo and Hydra. Lacking of bright stars, it can barely be seen. The constellation picture does not depict a glass cup, but a decorative prize trophy.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_crt_large.png`
    },
    {
        "name": "Crux",
        "abbr": "Cru",
        "best": "23-May",
        "season": "South Polar",
        "month": "May",
        "description": `Located amid the Milky Way, this constellation forms a cross with its 1st-magnitude stars Acrux and Becrux alongside a 2nd-magnitude and a 3rd-magnitude star. It is the smallest constellation in the sky, but well known as the Southern Cross. It can be seen at northern latitudes below 25 degrees. The five brightest stars are printed on the flag of Brazil to represent 5 of its 27 states. Crux can also be found on many other country flags, such as AUS, NZ and Papua New Guinea.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cru_large.png`
    },
    {
        "name": "Cygnus",
        "abbr": "Cyg",
        "best": "25-Sep",
        "season": "Summer",
        "month": "September",
        "description": `Delegating summer, Cygnus is also called the "Northern Cross", owing to its cross-like shape. At the tail of the "swan" shines the 1st-magnitude star Deneb. The binary star Albireo shines beautifully in yellow and blue at the nib. Cygnus is home to the majority of confirmed Kepler planets and the popular "North America" nebula (NGC 7000).`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_cyg_large.png`
    },
    {
        "name": "Delphinus",
        "abbr": "Del",
        "best": "26-Sep",
        "season": "Summer",
        "month": "September",
        "description": `A constellation located east of the Summer Triangle. Its shape is made of four stars forming a rhombus with another star in front. Although it is a small constellation it can be found easily by looking for a rhombus. Its principle star is a naked eye star of 4th-magnitude.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_del_large.png`
    },
    {
        "name": "Dorado",
        "abbr": "Dor",
        "best": "31-Jan",
        "season": "South Polar",
        "month": "January",
        "description": `Dorado is not Latin but Spanish. Based on the description of the sea voyager Theodorus in the 16th century, the constellation was created in the 17th century by astronomer Johann Bayer. At 25 degrees northern latitude it can be seen only partially in winter. Dorado is rich in deep sky objects. The Great Magellanic Cloud lies on the boundary with Mensa. The South ecliptic pole also lies within this constellation.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_dor_large.png`
    },
    {
        "name": "Draco",
        "abbr": "Dra",
        "best": "2-Aug",
        "season": "North Polar",
        "month": "July",
        "description": `Circumscribing Ursa Minor, Draco is an extended constellation in close vicinity to the Northern Pole Star. The brightest star Eltanin lies in the "dragon's" eye, while the 4th-magnitude star Thuban further out in the tail posed as the Northern Pole Star some 5,000 years ago.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_dra_large.png`
    },
    {
        "name": "Equuleus",
        "abbr": "Equ",
        "best": "5-Oct",
        "season": "Summer",
        "month": "September",
        "description": `Long, thin and shaping a triangle, this is the second smallest constellation in the sky located west of Enif at Pegasus" nose tip. In ancient Greek legend Equuleus is the brother of the winged horse Pegasus, however, the constellation picture paints only its head.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_equ_large.png`
    },
    {
        "name": "Eridanus",
        "abbr": "Eri",
        "best": "14-Jan",
        "season": "Winter",
        "month": "December",
        "description": `The "celestial river" that disappears at the horizon as heaving back and forth southwards from the west of Orion. The 1st-magnitude star Achernar at the end of the river -- below the horizon -- cannot be seen unless from northern vantages less than 30 degrees latitude.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_eri_large.png`
    },
    {
        "name": "Fornax",
        "abbr": "For",
        "best": "23-Dec",
        "season": "Winter",
        "month": "December",
        "description": `A constellation that appears engulfed by Eridanus. With only a few bright stars, it does not really stand out. Fornax is Latin for "furnace", an oven used for burning and distilling chemicals and for melting metals. Created in the 18th century by astronomer Louis de Lacaille.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_for_large.png`
    },
    {
        "name": "Gemini",
        "abbr": "Gem",
        "best": "3-Mar",
        "season": "Winter",
        "month": "February",
        "description": `Located in between Taurus and Cancer, Gemini is one of the 12 zodiac constellations. It is characterized by the "brother stars", 2nd-magnitude Castor and 1st-magnitude Pollux. The large open star cluster M35 resides at the feet of Castor.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_gem_large.png`
    },
    {
        "name": "Grus",
        "abbr": "Gru",
        "best": "22-Oct",
        "season": "Autumn",
        "month": "October",
        "description": `Located south of Pisces Austrinus, the stars of this constellation form an irregular cross. Two 2nd-magnitude stars between 1st-magnitude star Fomalhaut in Piscis Austrinus and the horizon are the eyemarks of Grus.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_gru_large.png`
    },
    {
        "name": "Hercules",
        "abbr": "Her",
        "best": "5-Aug",
        "season": "Summer",
        "month": "July",
        "description": `Almost approaching the zenith in summer, this constellation, situated in between Vega in Lyra and Arcturus in Bootes, depicts the body of the hero Herakles with its six stars arranged in the shape of the letter H. Hercules is home to the northernmost globular star cluster M13.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_her_large.png`
    },
    {
        "name": "Horologium",
        "abbr": "Hor",
        "best": "6-Jan",
        "season": "Winter",
        "month": "December",
        "description": `Located west of Achernar in Eridanus, this constellation is visible to observers at less than 30 degrees northern latitude. In the 18th century, astronomer Louis de Lacaille created the "pendulum clock" constellation in the southern hemisphere.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_hor_large.png`
    },
    {
        "name": "Hydra",
        "abbr": "Hya",
        "best": "25-Apr",
        "season": "Spring",
        "month": "April",
        "description": `The largest and longest constellation winding its way from west to east in the southern spring sky. There are no bright stars, however, the brightest, Alphard, depicting the heart of the "sea snake", can be found looking downwards from the 1st-magnitude star Regulus in Leo. On the flag of Brazil Alphard represents the state of Mato Grosso do Sul, gamma Hydrae the state of Acre.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_hya_large.png`
    },
    {
        "name": "Hydrus",
        "abbr": "Hyi",
        "best": "27-Dec",
        "season": "South Polar",
        "month": "December",
        "description": `Located south of Achernar in Eridanus, this constellation depicts an equilateral triangle with its three principle 3rd-magnitude stars. Hydrus is an eye-catching evening constellation in the southern hemisphere of November. Created in the 16th century by astronomer Johann Bayer.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_hyi_large.png`
    },
    {
        "name": "Indus",
        "abbr": "Ind",
        "best": "7-Oct",
        "season": "Summer",
        "month": "September",
        "description": `One of the 12 constellations in the southern hemisphere which German astronomer Johann Bayer created at the beginning of the 17th century. It looks like a distorted letter T, but represents an Indian holding an arrow. Indus can be seen at less than 20 degrees northern latitudes between summer and winter over the southern horizon.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_ind_large.png`
    },
    {
        "name": "Lacerta",
        "abbr": "Lac",
        "best": "24-Oct",
        "season": "Autumn",
        "month": "October",
        "description": `Located north of the forefoot of Pegasus, this constellation consists of zigzag-aligned stars fainter than 4 magnitudes. It can be found in the evening sky in autumn near the zenith. It was newly invented in the 17th century by astronomer Johannes Hevelius.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_lac_large.png`
    },
    {
        "name": "Leo",
        "abbr": "Leo",
        "best": "25-Apr",
        "season": "Spring",
        "month": "April",
        "description": `As one of the 12 zodiac constellations, Leo delegates spring in the northern hemisphere. The 1st-magnitude star Regulus shines in the heart of the "lion". The wavy, mirrored-shape is called the "Sickle of Leo" and is the radiant of the Leonids meteor shower observable every year in November.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_leo_large.png`
    },
    {
        "name": "Leo Minor",
        "abbr": "LMi",
        "best": "22-Apr",
        "season": "Spring",
        "month": "April",
        "description": `A small constellation between Ursa Major and Leo. 4 and 5-magnitude stars are lined up side by side, but can barely be realized. According to 17th century's astronomer Johannes Hevelius, Leo Minor was introduced to fill up space between the constellations.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_lmi_large.png`
    },
    {
        "name": "Lepus",
        "abbr": "Lep",
        "best": "6-Feb",
        "season": "Winter",
        "month": "February",
        "description": `A constellation with 73 visible stars, located south of Orion. In constellation pictures it is drawn as a hare trampled down by the hunting Orion.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_lep_large.png`
    },
    {
        "name": "Libra",
        "abbr": "Lib",
        "best": "6-Jul",
        "season": "Summer",
        "month": "June",
        "description": `One of the 12 zodiac constellations located west of Scorpius. Characterized by three 3rd-magnitude stars forming an irregular cross, Libra lies in the southern sky of June between Antares in Scorpius and Spica in Virgo.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_lib_large.png`
    },
    {
        "name": "Lupus",
        "abbr": "Lup",
        "best": "3-Jul",
        "season": "Spring",
        "month": "June",
        "description": `Situated between the constellations Centaurus and Scorpius, Lupus was formerly a part of Centaurus. In constellation pictures Lupus (the wolf) is drawn as stabbed by the spear of the centaur. Lupus can be seen between May and July low in the southern sky.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_lup_large.png`
    },
    {
        "name": "Lynx",
        "abbr": "Lyn",
        "best": "16-Mar",
        "season": "Spring",
        "month": "March",
        "description": `Located between Ursa Major and Gemini, the dim stars in this constellation describe a moderate arc. In the 17th century astronomer Johannes Hevelius introduced Lynx to fill up space between the constellations.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_lyn_large.png`
    },
    {
        "name": "Lyra",
        "abbr": "Lyr",
        "best": "29-Aug",
        "season": "Summer",
        "month": "August",
        "description": `Situated in between Cygnus and Hercules, Lyra's beacon is the 1st-magnitude star Vega, one of the Summer Triangle stars. At Vega's side is a parallelogram of four stars forming the "lyre". Likewise famous is the Ring Nebula Messier 57. Lyra is part of Kepler's field of view and home to numerous confirmed exoplanets.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_lyr_large.png`
    },
    {
        "name": "Mensa",
        "abbr": "Men",
        "best": "10-Feb",
        "season": "South Polar",
        "month": "January",
        "description": `Created by astronomer Louis de Lacaille in the 18th century, this constellation cannot be seen in the northern hemisphere. It is the faintest constellation in the entire sky. The "Table Mountain" south of Cape Town at the southern tip of Africa is an existent mountain with a flattened summit (Mensa). On its boundary with Dorado lies the Large Magellanic Cloud. Only two stars, Alpha and Pi (with a giant planet) are under 100 light-years away.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_men_large.png`
    },
    {
        "name": "Microscopium",
        "abbr": "Mic",
        "best": "30-Sep",
        "season": "Summer",
        "month": "September",
        "description": `This constellation can be seen in autumn east of Sagittarius near the horizon. Its shape resembles a square open at the right, but hardly noticeable since it lacks bright stars. The constellation was invented in the 18th century by astronomer Louis de Lacaille.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_mic_large.png`
    },
    {
        "name": "Monoceros",
        "abbr": "Mon",
        "best": "3-Mar",
        "season": "Winter",
        "month": "February",
        "description": `Wedged between the constellations Orion, Canis Major and Canis Minor, Monoceros is located in the center of the Winter Triangle. Since it contains no bright stars, the constellation is hard to find. The imaginary animal unicorn resembles a white horse with a single horn.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_mon_large.png`
    },
    {
        "name": "Musca",
        "abbr": "Mus",
        "best": "26-May",
        "season": "South Polar",
        "month": "May",
        "description": `Located south of the Southern Cross, Musca consists of 3rd and 4th-magnitude stars but can be found easily in a region of the southern sky with only few bright stars. Once it was called the Constellation of Bee, but was renamed as Musca ("fly") in the 18th century by astronomer Louis de Lacaille.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_mus_large.png`
    },
    {
        "name": "Norma",
        "abbr": "Nor",
        "best": "18-Jul",
        "season": "South Polar",
        "month": "July",
        "description": `Located south of Scorpio, sailors back in those days used Norma as a right-angle gauge to determine their position. The constellation is visible in whole at northern latitudes below 30 degrees, but it is hard to find because it lacks bright stars.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_nor_large.png`
    },
    {
        "name": "Octans",
        "abbr": "Oct",
        "best": "2-Oct",
        "season": "South Polar",
        "month": "October",
        "description": `Located at the south celestial pole, three 4th-magnitude stars of this constellation form a triangle, which can hardly be seen at northern latitudes. An "octant" is one of the instruments used for navigation and astronomical observations. Created by astronomer Louis de Lacaille. On the flag of Brazil the star sigma Octantis represents the Distrito Federal.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_oct_large.png`
    },
    {
        "name": "Ophiuchus",
        "abbr": "Oph",
        "best": "5-Aug",
        "season": "Summer",
        "month": "July",
        "description": `Displaying the shape of a large pentagon, this constellation is situated south of Hercules. The name of the 2nd-magnitude star, Rasalhague, is Arabic for "the head of the serpent-charmer". The figure represents the Greek healer Asclepius.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_oph_large.png`
    },
    {
        "name": "Orion",
        "abbr": "Ori",
        "best": "5-Feb",
        "season": "Winter",
        "month": "January",
        "description": `The constellation representing winter in the northern hemisphere is marked by three stars lined up in its center (belt stars). Among the surrounding four stars red Betelgeuse is at the top left while blue Rigel is at the bottom right. Below the belt asterism lies the Great Orion Nebula observable with the naked eye. Orion is also home to the diffuse nebula M78 and the famous Horsehead emission nebula, IC 434, both located near the belt.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_ori_large.png`
    },
    {
        "name": "Pavo",
        "abbr": "Pav",
        "best": "5-Sep",
        "season": "South Polar",
        "month": "September",
        "description": `Located near the celestial south pole, this constellation can be seen from the vantage of less than 30 degrees northern latitudes. The constellation lines describe a peacock with a stretched neck and raised tail feathers. The 2nd-magnitude star in the neck is also called "Peacock".`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_pav_large.png`
    },
    {
        "name": "Pegasus",
        "abbr": "Peg",
        "best": "25-Oct",
        "season": "Autumn",
        "month": "October",
        "description": `Around autumn, high in the northern sky, four 2nd-magnitude stars describe the body of the "winged horse", or the "Square of Pegasus". The square shape is a landmark for searching other autumn constellations.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_peg_large.png`
    },
    {
        "name": "Perseus",
        "abbr": "Per",
        "best": "6-Jan",
        "season": "Autumn",
        "month": "December",
        "description": `Located east of Andromeda, this constellation resembles the shape of the Greek letter lambda (?LAMBDA). At the raised sword in the constellation picture lies the beautiful double cluster designated h-?CHI. Furthermore, Perseus is famous for the location of the radiant of the Perseids meteor shower in summer.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_per_large.png`
    },
    {
        "name": "Phoenix",
        "abbr": "Phe",
        "best": "2-Dec",
        "season": "Autumn",
        "month": "November",
        "description": `A constellation with 2nd and 3rd-magnitude stars located north of Achernar in Eridanus. The constellation shows its whole figure if observed at 32 degrees northern latitude or lower and can be traced easily using Achernar as a celestial buoy. In ancient Egyptian mythology Phoenix is a mythical firebird.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_phe_large.png`
    },
    {
        "name": "Pictor",
        "abbr": "Pic",
        "best": "8-Feb",
        "season": "Winter",
        "month": "February",
        "description": `Invented in the 18th century by astronomer Louis de Lacaille. Located southwest of Canopus in Carina, the constellation can be seen at 25 degrees northern latitude in the south over the horizon. It resembles a canvas on a tripod with a paint palette.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_pic_large.png`
    },
    {
        "name": "Pisces",
        "abbr": "Psc",
        "best": "22-Nov",
        "season": "Autumn",
        "month": "November",
        "description": `One of the 12 zodiac constellations located south of Pegasus appearing to embrace the Square of Pegasus with its faint stars. In constellation pictures Pisces is drawn as two fish tied with a ribbon.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_psc_large.png`
    },
    {
        "name": "Piscis Austrinus",
        "abbr": "PsA",
        "best": "17-Oct",
        "season": "Autumn",
        "month": "October",
        "description": `Located south of Aquarius, its constellation picture shows it as drinking down the water flowing from Aquarius. The other name for the 1st-magnitude star Fomalhaut is "Lonely Star of Autumn", since it is the only 1st-magnitude star in the autumn sky.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_psa_large.png`
    },
    {
        "name": "Puppis",
        "abbr": "Pup",
        "best": "13-Mar",
        "season": "Winter",
        "month": "March",
        "description": `Located north of Canopus in Carina, this constellation depicts the stern of Argo Navis. Puppis is Latin for "stern". Formerly, it was the constellation of Argo segmented in the 18th century by astronomer Louis de Lacaille.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_pup_large.png`
    },
    {
        "name": "Pyxis",
        "abbr": "Pyx",
        "best": "31-Mar",
        "season": "Spring",
        "month": "March",
        "description": `Pyxis is the northernmost constellation separated from the former constellation Argo. Featureless and consisting solely of dim stars, Pyxis is best found in late winter nights and evenings in spring by way of looking from Canis Major to Puppis. Pyxis is Latin for a mariner's compass, unlike Circinus, which is Latin for a draftsman's compass.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_pyx_large.png`
    },
    {
        "name": "Reticulum",
        "abbr": "Ret",
        "best": "14-Jan",
        "season": "Winter",
        "month": "January",
        "description": `A rhombus-shaped constellation made of 3rd and 4th-magnitude stars. It can be seen at 25 degrees northern latitude in January on the southern horizon, but is hard to find because of its low elevation. Reticulum is Latin for "reticle", crosshair lines such as used in telescopes, or a gauge.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_ret_large.png`
    },
    {
        "name": "Sagitta",
        "abbr": "Sge",
        "best": "12-Sep",
        "season": "Summer",
        "month": "September",
        "description": `Located south of Cygnus with Vulpecula in between, this constellation forms a "Y" and is the third smallest. Sagitta can be found quickly sweeping with binoculars around Altair in Aquila.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_sge_large.png`
    },
    {
        "name": "Sagittarius",
        "abbr": "Sgr",
        "best": "2-Sep",
        "season": "Summer",
        "month": "August",
        "description": `One of the 12 zodiac constellations which forms the Southern Dipper (part of the "Teapot") with six of its stars. As seen from Earth, Sagittarius lies in the direction to the galaxy center where the Milky Way is most dense and bright containing numerous nebulae and star clusters.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_sgr_large.png`
    },
    {
        "name": "Scorpius",
        "abbr": "Sco",
        "best": "23-Jul",
        "season": "Summer",
        "month": "July",
        "description": `The S-shaped "delegate of summer" is one of the 12 zodiac constellations. The 1st-magnitude star Antares shines in red in the heart of the "scorpion". It's name means "anti-Mars" because of the rivalling red colors. Among numerous nebulae and clusters of stars, the open star cluster M6 at the tail of the "scorpion" is particularly beautiful. The eight brightest stars are printed on the flag of Brazil to represent 8 of its 27 states.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_sco_large.png`
    },
    {
        "name": "Sculptor",
        "abbr": "Scl",
        "best": "25-Nov",
        "season": "Autumn",
        "month": "November",
        "description": `A constellation without distinctive stars located south of Cetus. Its constellation picture draws a plaster figure and a table with a chisel on it. In the 18th century, French astronomer Louis de Lacaille introduced Sculptor to fill up space between the constellations.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_scl_large.png`
    },
    {
        "name": "Scutum",
        "abbr": "Sct",
        "best": "25-Aug",
        "season": "Summer",
        "month": "August",
        "description": `This constellation commemorates the victory of a Polish hero over the Ottoman Empire. It lies in the south of Aquila along the Milky Way. The open star cluster M11 hovering in the Milky Way is a must-see.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_sct_large.png`
    },
    {
        "name": "Serpens",
        "abbr": "Ser",
        "best": "12-Jul",
        "season": "Summer",
        "month": "July",
        "description": `Embracing Ophiuchus, this constellation is divided into head and tail. The head extends from the bottom right star in Ophiuchus in direction to Bootes, the tail from the bottom left star towards Aquila. The beautiful open star cluster M5 resides south of the head.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_ser_large.png`
    },
    {
        "name": "Sextans",
        "abbr": "Sex",
        "best": "20-Apr",
        "season": "Spring",
        "month": "April",
        "description": `Located south of Regulus in Leo, this constellation depicts a widely opened letter V. A sextant is an instrument for determining the altitude of stars. Astronomer Johannes Hevelius introduced Sextans to fill up space between the constellations.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_sex_large.png`
    },
    {
        "name": "Taurus",
        "abbr": "Tau",
        "best": "24-Jan",
        "season": "Winter",
        "month": "January",
        "description": `One of the 12 zodiac constellations marked by the 1st-magnitude star Aldebaran shining at the upper right of Orion. Taurus contains the Hyades and Plejades star clusters which can be seen with the naked eye even in cities, however, observation with a pair of binoculars is more rewarding.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_tau_large.png`
    },
    {
        "name": "Telescopium",
        "abbr": "Tel",
        "best": "2-Sep",
        "season": "Summer",
        "month": "August",
        "description": `Located south of Sagittarius with Corona Australis in between, this constellation can be low south in the evening sky of summer, but is not spectacular with its 3rd to 5th-magnitude stars. Created in the 18th century by astronomer Louis de Lacaille.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_tel_large.png`
    },
    {
        "name": "Triangulum",
        "abbr": "Tri",
        "best": "17-Dec",
        "season": "Autumn",
        "month": "December",
        "description": `Located south of Andromeda and, as the name suggests, is of triangular shape formed by three 3rd-magnitude stars which can easily be recognized. It was invented by the ancient Greek who saw the shape of the Greek letter delta (DELTA).`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_tri_large.png`
    },
    {
        "name": "Triangulum Australis",
        "abbr": "TrA",
        "best": "13-Jul",
        "season": "South Polar",
        "month": "July",
        "description": `Located south of Centaurus with Circinus in between, this constellation is of triangular shape formed by 2nd and 3rd magnitude stars. The names Atria, Gatria are abbreviated for Alpha, Gamma Trianguli Australis. Visible at northern latitudes below 25 degrees. The three brightest stars are printed on the flag of Brazil to represent 3 of its 27 states.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_tra_large.png`
    },
    {
        "name": "Tucana",
        "abbr": "Tuc",
        "best": "13-Nov",
        "season": "South Polar",
        "month": "November",
        "description": `Invented in the 17th century by astronomer Johann Bayer, this constellation can be seen in autumn at the horizon at northern latitudes below 20 degrees. A toucan is a bird with a large nib living in the jungles of Latin America. Tucana is home to the globular star cluster 47 Tucanae, 120 light-years across and the second brightest known after Omega Centauri.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_tuc_large.png`
    },
    {
        "name": "Ursa Major",
        "abbr": "UMa",
        "best": "3-May",
        "season": "North Polar",
        "month": "April",
        "description": `Characterized by the seven stars that form the Big Dipper. Taking this for the tail and connecting a number of faint stars below, the constellation of the "bear" becomes apparent. Five of the Big Dipper stars are actually near each other in space and were likely formed at nearly the same time. Connecting two stars in the far part of the Big Dipper (Merak and Dubhe) will lead one to Polaris, the North Star, which is part of the Little Dipper. Relative stellar motions will cause the Big Dipper to slowly change its apparent configuration over the next 100,000 years. Likewise well known is the binary pair Mizar and Alcor.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_uma_large.png`
    },
    {
        "name": "Ursa Minor",
        "abbr": "UMi",
        "best": "13-Jul",
        "season": "North Polar",
        "month": "June",
        "description": `A constellation in the north celestial pole. Its seven stars are forming a dipper, but not as spectacular as the Big Dipper. In the constellation picture the 2nd-magnitude North Pole Star is painted in the tail of the "little bear". There are no notable deep sky objects, however, Ursa Minor is the radiant of the Ursids meteor showers.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_umi_large.png`
    },
    {
        "name": "Vela",
        "abbr": "Vel",
        "best": "10-Apr",
        "season": "Winter",
        "month": "March",
        "description": `Located north of Carina, this constellation can be seen in whole at 30 degrees northern latitude in the evening sky of spring. Vela shaping a cross together with 2nd-magnitude stars in Carina is often mistaken for the Southern Cross, for which reason it is called the "False Cross".`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_vel_large.png`
    },
    {
        "name": "Virgo",
        "abbr": "Vir",
        "best": "7-Jun",
        "season": "Spring",
        "month": "May",
        "description": `One of the 12 zodiac constellations which lies at the end point of a curve drawn down from the Big Dipper. Resembling the shape of the letter Y, Virgo is the second largest constellation in the sky. Among the dense number of galaxies is the famous Sombrero galaxy. On the flag of Brazil Spica represents the state of Para.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_vir_large.png`
    },
    {
        "name": "Volans",
        "abbr": "Vol",
        "best": "13-Mar",
        "season": "South Polar",
        "month": "March",
        "description": `Located south of Carina, this constellation consists of a number of 4th-magnitude stars. Volans was created by astronomer Johann Bayer. At first it was the "Southern Flying Fish", later it was shortened to "Flying Fish". The constellation can be seen at 15 degrees northern latitude or lower. There are two double stars within the constellation which can be observed using a small telescope, Gamma Volantis and Epsilon Volantis.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_vol_large.png`
    },
    {
        "name": "Vulpecula",
        "abbr": "Vul",
        "best": "20-Sep",
        "season": "Summer",
        "month": "September",
        "description": `Located south of Cygnus, this constellation was created in the 17th century by astronomer Johannes Hevelius. Constellation pictures draw a fox biting a goose. At the forepaw of the "little fox" lies the famous "Dumbbell", a planetary nebula.`,
        "image": `https://www.astropical.space/images/cns/grid_icon_mark_vul_large.png`
    }
];